<infl-widget-wrapper
  [widget]="widget()"
  [actions]="actions"
  (actionClick)="onActionClick($event)"
>
  @if (displayOptions()) {
    <div class="wrapper-options">
      <div class="title">
        {{ 'i18n.component.widget-time-component.options.title' | translate }}
      </div>
      <div class="field">
        <inf-combo
          [title]="'i18n.common.color' | translate"
          [dataSource]="colors$"
          [value]="color()"
          [required]="true"
          (selectItem)="onSelectItem($event)"
        />
      </div>
    </div>
  } @else {
    <div class="wrapper-clock" style="--color: {{ color() }};">
      <div class="clock">
        <div #hoursHand class="hour-hand"></div>
        <div #minutesHand class="minute-hand"></div>
        <div #secondsHand class="second-hand"></div>
      </div>
    </div>
  }
</infl-widget-wrapper>
